import React from 'react';
import { Link } from 'react-router-dom';
import LogoImage from '../../../images/logo.png';

const Header = () => {
    return (
        <header className='publicHeader'>
            <nav>
                <Link to='/' className='logo'>
                    <img src={LogoImage} alt='UcarParts logo' />
                </Link>
                <div className='navigation'>
                    <Link to='/login'>
                        Prisijungti
                    </Link>
                    {/* <Link to='/register'>
                        Registruotis
                    </Link> */}
                </div>
            </nav>
        </header>
    );
};

export default Header;